<template>
    <div>
        <div class="mediu-grafice">
            <div class="grafic row">
                <div class="col-md-3">
                    <apexchart type="pie" width="250" :options="chartOptions1" :series="calculateEnvironmentValue"></apexchart>
                </div>
                <div class="col-md-3">
                    <div style="display: flex; flex-direction: column;">
                        <p class="green-text">Valoarea cheltuielilor care contribuie la obiectivele de mediu</p>
                        <p class="price-text">{{ parseFloat(calculateEnvironmentValue[0]).toFixed(2) }} lei</p>
                    </div>
                    <div style="display: flex; flex-direction: column; margin-top: 10px;">
                        <p class="orange-text">Cheltuieli care nu contribuie la obiectivele de mediu</p>
                        <p class="price-text">{{ parseFloat(calculateEnvironmentValue[1]).toFixed(2) }} lei</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <p>În conformitate cu prevederile Anexei I din  REGULAMENTUL DELEGAT AL COMISIEI (UE) de completare a Regulamentului (UE) 2020/852 al Parlamentului European și al Consiliului privind stabilirea criteriilor tehnice de screening pentru determinarea condițiilor în care o activitate economică se califică ca contribuind în mod substanțial la atenuarea schimbărilor climatice sau adaptarea la schimbările climatice și pentru a stabili dacă acea activitate economică nu cauzează nici un prejudiciu semnificativ oricăruia dintre celelalte obiective de mediu.</p>
                </div>
            </div>
            <div class="grafic row mt-4">
                <div class="col-md-5">
                    <apexchart type="donut" width="380" :options="chartOptions2" :series="series2"></apexchart>
                </div>
                <div class="list-prices col-md-7">
                    <div v-for="(value, key) in chartOptions2.labels" :key="key" class="price" :class="{'mt-4': key == chartOptions2.labels.length - 1}">
                        <span :class="{'percent': true}" :style="{background: chartOptions2.colors[key]}">{{ calculateEnvironmentPercentage(value) }}%</span> {{ value }}
                    </div>
                </div>
            </div>
        </div>
        <b-form class="mt-4">
            <PlanInputContent
                title="I. Contribuția proiectului la obiectivele de mediu"
                warn="Se va descrie în detaliu cum fiecare investiție din cadrul proiectului contribuie la obiectivele de mediu în conformitate cu prevederile Anexei I din REGULAMENTUL DELEGAT AL COMISIEI (UE) de completare a Regulamentului (UE) 2020/852 al Parlamentului European și al Consiliului privind stabilirea criteriilor tehnice de screening pentru determinarea condițiilor în care o activitate economică se califică ca contribuind în mod substanțial la atenuarea schimbărilor climatice sau adaptarea la schimbările climatice și pentru a stabili dacă acea activitate economică nu cauzează nici un prejudiciu semnificativ oricăruia dintre celelalte obiective de mediu."
            >
                <template v-slot:body>
                    <div class="sub-item">
                        <validation-observer ref="observer" #default="{ invalid }">
                            <span class="display-none">{{ invalid }}</span>
                            <div class="textarea">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-textarea
                                        v-model="form.text"
                                        rows="4"
                                        max-rows="20"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        style="font-size: 13px;"
                                        @input="$emit('unsavedChanges', !!form.text.length)"
                                    ></b-form-textarea>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                                <b-icon-pencil-square font-scale="1.2"></b-icon-pencil-square>
                            </div>
                        </validation-observer>
                    </div>
                </template>
            </PlanInputContent>
            <p class="contributiaSubsection">Contribuția fiecărei cheltuieli la obiectivele de mediu se justifică în secțiunea <router-link to="/aplicatii/m3-sketch/achizitii-cheltuieli" style="color: #515679">Achiziții / Cheltuieli</router-link>. Anexele vor fi atașate automat la planul de afaceri</p>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill, BOverlay, BFormGroup, BFormFile} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import Vue from 'vue'
    import _ from "lodash";
    import VueApexCharts from 'vue-apexcharts'
    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)
    export default {
        name: 'ContributiaProiectuluiMediu',
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            BOverlay,
            BFormGroup,
            BFormFile,
            ValidationProvider, ValidationObserver
        },
        data() {
            return {
                completed: false,
                form: {
                    text: ''
                },
                environmentValue: 0,
                budgetTotal: 0,
                chartOptions1: {
                    colors: ['#0cc2aa', '#ff9c44'],
                    chart: {
                        type: 'pie',
                    },
                    labels: ['', ''],
                    dataLabels: {
                        formatter: function (val) {
                            return val.toFixed(2) + '%'
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'Montserrat, sans-serif',
                            colors: undefined
                        },
                        background: {
                            foreColor: '#fff',
                            padding: 4,
                            borderRadius: 2,
                            borderWidth: 1,
                            borderColor: '#fff',
                        },
                        dropShadow: {
                            enabled: false,
                        }
                    },
                    plotOptions: {
                        pie: {
                            customScale: 0.9,
                            dataLabels: {
                                offset: 45,
                            },
                            startAngle: -40,
                            endAngle: 330,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
                series2: [0],
                chartOptions2: {
                    colors: ['#90e9e3', '#2bd5cb', '#2bd5a3', '#1ec07a', '#92da5c', '#cdf628', '#c5ff9b', '#ffda44'],
                    chart: {
                        type: 'donut',
                    },
                    labels: [''],
                    dataLabels: {
                        formatter: function (val) {
                            return val.toFixed(2) + '%'
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'Montserrat, sans-serif',
                            colors: undefined
                        },
                        background: {
                            foreColor: '#fff',
                            padding: 4,
                            borderRadius: 2,
                            borderWidth: 1,
                            borderColor: '#fff',
                        },
                        dropShadow: {
                            enabled: false,
                        }
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                offset: 55,
                            },
                            startAngle: -30,
                            endAngle: 330,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                        }
                    }]
                },
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            },
            calculateEnvironmentValue() {
                if(this.series2.length > 1) {
                    let env = _.cloneDeep(this.series2.slice(0, -1)).reduce((total, val) => {
                        return total + val;
                    })

                    return [ env, this.series2[this.series2.length - 1] ]
                }

                return [0, 0]
            },
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriContributieMediu;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            statistics: {
                handler: function(stats) {
                    this.chartOptions2.labels = stats && stats.environment_percentage_chart_data ? Object.keys(stats.environment_percentage_chart_data): []
                    this.series2 = stats && stats.environment_percentage_chart_data ? Object.values(stats.environment_percentage_chart_data).map(item => item.value) : []
                },
                immediate: true
            },
            allData: {
                handler () {
                    if(this.allData && this.allData.m3_project && this.allData.m3_project.business_plan_green_environment && this.allData.m3_project.business_plan_green_environment.business_plan_green_environment){
                        this.form.text = this.allData.m3_project.business_plan_green_environment.business_plan_green_environment
                        this.completed = true
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.allData && this.allData.m3_project && this.allData.m3_project.business_plan_green_environment && this.allData.m3_project.business_plan_green_environment.business_plan_green_environment){
                this.form.text = this.allData.m3_project.business_plan_green_environment.business_plan_green_environment
                this.completed = true
            }
        },
        methods: {
            calculateEnvironmentPercentage(value) {
                if(this.statistics) {
                    return this.statistics.environment_percentage_chart_data[value].percentage
                }

                return 0;
            },
            uploadFile(e) {
                let form = new FormData;
                if (e.target.files.length > 0) {
                    form.append('reference', e.target.files[0]);
                    form.append('_method', 'PUT');
                    axios.post(api.API_ENDPOINTS.invoices + '/' + this.selectedId + '/upload', form)
                        .then(response => {
                            this.getCompanies()
                            this.$toast.success(response.data.message);
                            this.uploadedDocument = null;
                            this.$refs.fileUpload.value = null;
                            this.selectedId = null
                        }).catch(() => {
                            this.$toast.error('Te rugăm încarcă un fisier in format PDF mai mic de 20MB.')
                        });
                }
            },
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.formSend = {
                                business_plan_green_environment: {
                                    business_plan_green_environment: this.form.text,
                                    checked: this.completed
                                }
                            }
                            this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                                .then((firstResponse) => {
                                    this.$toast.success(firstResponse.data)
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }
                    }
                })
                if(this.checks.planDeAfaceriContributieMediu !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriContributieMediu', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.mediu-grafice{
    margin-top: 55px;
    margin-bottom: 20px;
}
.orange-text, .green-text, .price-text{
    font-size: 15px;
    font-weight: 500;
    max-width: 260px;
    text-align: right;
}
.grafic{
    align-items: center;
    background: #f6f7f8;
    padding: 25px 15px;
}
.green-text{
    color: #0cc2aa;
}
.list-prices{
    display: flex;
    flex-direction: column;
}
.price{
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-bottom: 10px;
}
.price .percent{
    margin-right: 10px;
    padding: 2px 10px;
    font-size: 12px;
    width: 65px;
    min-width: 65px;
    text-align: center;
}
.orange-text{
    color: #ff9c44;
}
.textarea{
    position: relative;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.contributiaSubsection {
	color: #515679;
	background: #e9eaec;
	text-align: center;
	font-size: 13px;
	padding: 15px;
	margin-top: 10px;
	font-weight: 700;
}
</style>
